import { ReactElement } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { AirSampler } from "@/services/backend/airsamplers/air-sampler";
import { useListAirSamplersQuery } from "@/services/backend/airsamplers/service";
import { Label } from "../../ui/label";

interface AirSamplerSelectorProps {
  preset?: string;
  disabled?: boolean;
  onChange: (sampler: AirSampler) => void;
}

export function AirSamplerSelector({
  preset,
  disabled = false,
  onChange,
}: AirSamplerSelectorProps): ReactElement {
  const { data } = useListAirSamplersQuery({ limit: 0, offset: 0 });

  if (!data) {
    return <div />;
  }

  return (
    <div className="flex flex-col space-y-1">
      <Label>Luftkeimsammler</Label>
      <Select
        disabled={disabled}
        defaultValue={preset}
        onValueChange={(val) => {
          const sampler = data.items.find((item) => item.originalId === val);
          onChange({
            id: sampler!.originalId,
            originalId: sampler!.originalId,
            description: sampler!.description,
            holeCount: sampler!.holeCount,
          });
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Luftkeimsammler" />
        </SelectTrigger>
        <SelectContent>
          {data.items.map((item) => (
            <SelectItem key={item.originalId} value={item.originalId}>
              {item.description}, Lochzahl: {item.holeCount}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
